<template>
  <div class="d-flex py-5">
    <div class="d-flex align-items-center flex-fill">
      <select v-if="options?.status" name="text" class="form-control flex-fill">
        <option value="All" class="text-center">All</option>
      </select>
      <select v-if="options?.date" name="text" class="form-control flex-fill">
        <option value="All" class="text-center">Dec 2025 - May 2026</option>
      </select>
      <input class="form-control flex-fill" placeholder="Search" />
    </div>
    <button v-if="options?.create" class="btn btn-dark fw-bold" add-application>
      +
    </button>
  </div>
</template>

<script>
export default {
  name: "FilterComp",
  props: {
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>
[add-application] {
  aspect-ratio: 1;
}
</style>
